"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconPersonalInfo = void 0;
var React = __importStar(require("react"));
var IconPersonalInfo = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M18.4287,21 L5.5717,21 C5.2557,21 4.9997,20.75 4.9997,20.444 L4.9997,3.556 C4.9997,3.25 5.2557,3 5.5717,3 L13.9997,3 L13.9997,6.691 C13.9997,7.411 14.5977,8 15.3287,8 L18.9997,8 L18.9997,20.444 C18.9997,20.75 18.7437,21 18.4287,21 M19.5487,6.282 L15.7517,2.465 C15.4587,2.169 15.0507,2 14.6317,2 L5.5717,2 C4.7047,2 3.9997,2.698 3.9997,3.556 L3.9997,20.444 C3.9997,21.302 4.7047,22 5.5717,22 L18.4287,22 C19.2947,22 19.9997,21.302 19.9997,20.444 L19.9997,7.373 C19.9997,6.963 19.8397,6.576 19.5487,6.282" }))); };
exports.IconPersonalInfo = IconPersonalInfo;
exports.IconPersonalInfo.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconPersonalInfo;
